<div class="tile-container" [class.selected]="rule.viewSw">
  <checkbox-wrap class="checkbox">
    <input type="checkbox" [(ngModel)]="rule.checkedSw" />
  </checkbox-wrap>

  <div class="id footnote">
    {{ "translate.rev.Id" | translate }}: {{ rule.revRuleId }}

    <span *ngIf="displayPageNum"> | </span>
    <span *ngIf="displayPageNum && rule.pageNum == curPage">
      {{ "translate.general.page" | translate }}: {{ rule.pageNum }}</span>

    <a *ngIf="displayPageNum && rule.pageNum != curPage" (click)="goToPage()">
      {{ "translate.general.page" | translate }}: {{ rule.pageNum }}</a>
    <reeval-status-icon [target]="reevalTarget" (refresh)="onReevalRefresh()"></reeval-status-icon>
  </div>

  <div class="phrase">
    <div *ngIf="isPhrase">
      <p class="t-footnote">
        {{ rule.revRuleContentTypeDesc }}
      </p>
      <div *ngIf="rule.revRuleType != 'BX_MATCH'">
        <formatted-phrase [phraseWords]="rule.ruleDispWords"></formatted-phrase>
      </div>

      <div *ngIf="rule.revRuleType == 'BX_MATCH'">
        <p class="fw-semibold" [class.missing]="rule.similarityCode == 'MISSING'">
          {{ "translate.general.boundingBox" | translate }} &middot;
          {{ rule.boundingBoxMatch.boundingBox.boxType.text }}
        </p>
        <span [class.missing]="rule.similarityCode == 'MISSING'">
          {{ rule.boundingBoxMatch.boundingBox.descr }}</span>
      </div>
    </div>

    <div *ngIf="!isPhrase">
      <p class="t-footnote figure-type">
        {{ rule.figureTypeDescr }}
        <span *ngIf="rule.figureSubType">&middot; {{ rule.figureSubType.text }}</span>
      </p>
      <async-img class="t-pointer" [className]="'ind-img'" [url]="rule.imgUrl"
        (click)="onRuleDetailsClicked()"></async-img>
    </div>
  </div>

  <div class="type">
    <button class="rev-rule-type-desc-tile"
      [ngClass]="['rev-rule-type-descr', rule.revRuleSimilarityEvent || rule.revRuleType]"
      (click)="onRuleDetailsClicked($event)">
      {{ rule.revRuleSimilarityEventDesc || rule.revRuleTypeDescr }}
    </button>
    <div class="tile-icon-indicators">
      <!--
      <i *ngIf="!!libraryMismatch" class="task" tooltip="{{ libraryMismatch[1] }}"
        tooltipPosition="bottom"></i>
      -->
      <i *ngIf="!!referenceIssues" class="rule" tooltip="{{ referenceIssues[1] }}" tooltipPosition="bottom"></i>
      <i *ngIf="!!contentPartMismatch" class="warning" tooltip="{{ contentPartMismatch[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!spellingGrammarIssues" class="spellcheck" tooltip="{{ spellingGrammarIssues[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!formatMismatch" class="format" tooltip="{{ formatMismatch[1]
      }}" tooltipPosition="bottom"></i>
      <i *ngIf="!!consistencyIssues" class="priority-high" tooltip="{{ consistencyIssues[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!fairBalanceIssues" class="balance" tooltip="{{ fairBalanceIssues[1] }}"
        tooltipPosition="bottom"></i>
      <i *ngIf="!!complianceIssues" class="policy-alert" tooltip="{{ complianceIssues[1] }}"
        tooltipPosition="bottom"></i>
    </div>
  </div>
  <p *ngIf="rule.revStatusCode" [ngClass]="['rev-rule-status', rule.revStatusCode]">
    {{ rule.revStatusDescr }}
  </p>
  <spinner *ngIf="!rule.revStatusCode" class="rev-rule-status-spinner"></spinner>

  <div *ngIf="rule.addInstr && rule.addInstr.length > 0" class="instructions">
    <p class="title">{{ "translate.rev.instructions" | translate }}:</p>
    <div *ngFor="let instr of rule.addInstr">
      <p class="text">{{ instr.text }}</p>
    </div>
  </div>

  <div *ngIf="editable" class="btn">
    <p-selectButton *ngIf="editable" [disabled]="rule.parentPhraseId != null && !rule.isParentActionSelected" class="rev-status" [options]="ruleStatusOptions" [(ngModel)]="rule.ruleUserStatus"
      (onChange)="onRevStatusChange()"></p-selectButton>

    <i *ngIf="rule.comment" class="far fa-comment-alt icon" (click)="onRuleDetailsClicked($event)"
      tooltip="{{ rule.comment }}"></i>
  </div>
  <claim-tool *ngIf="showClaimToolDialog && isPhrase" (showDetailsDialogEmitter)="showDetailsDialog($event)" (onClose)="showClaimToolDialog = false" [claim]="claimToolElement"></claim-tool>
  <div class="icons">
    <div>
      <i
      style="margin-right: 10px"
      *ngIf="editable && isPhrase"
      class="fas fa-file-invoice icon"
      (click)="showClaimTool()"
      tooltip="{{ claimToolLabel | translate }}"
    ></i>
    </div>
    <i *ngIf="rule.pageNum == curPage && rule.similarityCode !== 'MISSING'" class="icon fas fa-eye icon-view"
      [class.selected]="rule.viewSw" (click)="toggleRuleView($event)"
      [tooltip]="'translate.general.viewAnnotation' | translate"></i>
  </div>
  <div class="image-categories" style="left: 1em !important; margin-left: 10px">
      <div *ngIf="rule.figureCategory" class="cat-phrase-type">        
      {{ rule.figureCategory }}
      </div>
  </div>

</div>
<div *ngIf="isPhrase && rule.revRuleSimilarityEvent">
  <phrase-rev-rule-details *ngIf="ruleDetailsOpenSw" (onClose)="closeDetailsDialog()"
  [hasNext]="hasNext"
  [hasPrev]="hasPrev"
    (onStatusChange)="onRevStatusChange()" [focusOnOpen]="focusRuleDetailsOnOpen" (onUpdateSpellingIssues)="notifySpellingIssuesUpdate()"
    (showNextRuleEmitter)="showNextRule($event)" (showPrevRuleEmitter)="showPrevRule($event)"
    (showClaimToolEmitter)="showClaimTool()"
    (hideRuleAnnotation)="hideRuleAnnotation()"
    (setDisplayDetailsDialogActionsFlag)="checkIfRevRuleHasSelectedUserStatus($event)"
    [referenceDocuments]="referenceDocuments"
    ></phrase-rev-rule-details>
</div>
<div *ngIf="!isPhrase || !rule.revRuleSimilarityEvent">
  <rev-rule-details *ngIf="ruleDetailsOpenSw" (onClose)="closeDetailsDialog()"
    (onStatusChange)="onRevStatusChange()" [focusOnOpen]="focusRuleDetailsOnOpen"
    [hasNext]="hasNext"
    [hasPrev]="hasPrev"
    (showNextRuleEmitter)="showNextRule($event)"
     (showPrevRuleEmitter)="showPrevRule($event)"
     (hideRuleAnnotation)="hideRuleAnnotation()"></rev-rule-details>
</div>
<ng-container
*ngIf="isPhrase && rule.associatedText && rule.associatedText.length > 0 && 
(rule.showAssociatedTextSection)">
    <div style="margin-left: 20px">
      <p-panel  [header]="('translate.general.associatedText' | translate) + ' (' + rule.associatedText.length + ')'"
        [toggleable]="true"
        [collapsed]="true"
        [style]="{position: 'relative', top: '-1.5em'}"
        >
        <div  class="associatedText">
      <ng-container *ngIf="rule.showAssociatedTextSection">
      <ng-container *ngFor="let assocPhrase of rule.associatedText" class="ref-container">
        <ng-container *ngIf="assocPhrase.showInTile">
          <div class="ref-container">
            <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
              {{ assocPhrase.assocPhraseText }}
            </p>
            <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" class="text"
              [phraseWords]="assocPhrase.phraseDispWords"></formatted-phrase>
        </div>
        </ng-container>
      </ng-container>
      </ng-container>
    </div>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="isPhrase && rule.showFootnotesSection">
    <div style="margin-left: 20px">

      <p-panel  [header]="('translate.rev.footnotes' | translate) + ' (' + rule.numberOfFootnotes + ')'"
        [toggleable]="true"
        [collapsed]="true"
        [style]="{position: 'relative', top: '-1.5em'}"
        >
        <ng-container *ngFor="let footnote of rule.referencesInFootnotesSection">
          <div class="reference">
            <div class="ref-container ref-with-view">
              <p *ngIf="footnote.phraseDispWords.length == 0" class="text">
                {{ footnote.refPhraseText }}
              </p>
              <formatted-phrase *ngIf="footnote.phraseDispWords.length > 0" class="text"
                [phraseWords]="footnote.phraseDispWords"></formatted-phrase>

              <div class="ref-view-action" *ngIf="canViewRefDoc(footnote)">
                <i
                  style="cursor: pointer; color: #0978a2"
                  class="icon fa-solid fa-arrow-up-right-from-square"
                  [class.selected]="true"
                  [tooltip]="'translate.general.viewRefDoc' | translate"
                  (click)="viewRefDoc(footnote)">
                </i>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="footnotesTemplate"></ng-container>
      </p-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="isPhrase && rule.references && rule.numOfContextCatPhrases > 0 && rule.showReferencesSection">
      <div style="margin-left: 20px !important">
        <p-panel  [header]="('translate.rev.reference' | translate) + ' (' + rule.numOfContextCatPhrases + ')'"
          [toggleable]="true"
          [collapsed]="true"
          [style]="{ position: 'relative', top: '-1.5em' }">
        

        <ng-container *ngFor="let ref of rule.references">
          <ng-container *ngIf="ref.showInTile">
            <div class="reference">
              <div class="ref-container ref-with-view" [ngClass]="ref.isConsistencyGenerated ? 'border-indicator-anchor' : 'border-indicator-reference'">
                <p *ngIf="ref.phraseDispWords.length == 0" class="text">
                  {{ ref.refPhraseText }}
                </p>
                <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
                  [phraseWords]="ref.phraseDispWords"></formatted-phrase>

                <div class="ref-view-action" *ngIf="canViewRefDoc(ref)">
                  <i
                    style="cursor: pointer; color: #0978a2"
                    class="icon fa-solid fa-arrow-up-right-from-square"
                    [class.selected]="true"
                    [tooltip]="'translate.general.viewRefDoc' | translate"
                    (click)="viewRefDoc(ref)">
                  </i>
                </div>

                <ng-container *ngIf="ref.anchors != null">
                  <mng-anchors
                    [anchors]="ref.anchors"
                    [phrase]="curRule"
                    [simpleView]="true"
                  ></mng-anchors>
                </ng-container>
              </div>
            </div>
            </ng-container>
          </ng-container>
  </p-panel>
  </div>
  </ng-container>
  <ng-container *ngIf="rule.associatedBy && rule.numberOfAssociatedBy > 0 && rule.showAssociatedBySection">
      <div style="margin-left: 20px;">
        <p-panel  [header]="('translate.general.associatedBy' | translate) + ' (' + rule.numberOfAssociatedBy + ')'"
          [toggleable]="true"
          [collapsed]="true"
          [style]="{ position: 'relative', top: '-1.5em' }"
          >
        <div  class="associatedBy">
        <ng-container *ngFor="let assocPhrase of rule.associatedBy">
          <ng-container *ngIf="assocPhrase.showInTile">
            <div class="ref-container">
              <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
                {{ assocPhrase.assocPhraseText }}
              </p>
              <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" class="text"
                [phraseWords]="assocPhrase.phraseDispWords"></formatted-phrase>
            </div>
            </ng-container>
          </ng-container>
      </div>
      </p-panel>
  </div>
  </ng-container>
    <ng-container *ngIf="isPhrase && rule.referencedBy && rule.numberOfReferencedBy > 0 && rule.showReferencedBySection">
      <div style="margin-left: 20px !important">
      <p-panel  [header]="('translate.rev.referencedBy' | translate) +  ' (' + rule.numberOfReferencedBy + ')'"
        [toggleable]="true"
        [collapsed]="true"
        [style]="{ position: 'relative', top: '-1.5em' }"
        >
      <div  class="referencedBy">
      <ng-container *ngFor="let ref of rule.referencedBy">
        <ng-container *ngIf="ref.showInTile">
          <div class="ref-container">
            <p *ngIf="ref.phraseDispWords.length == 0" class="text">
              {{ ref.refPhraseText }}
            </p>
            <formatted-phrase *ngIf="ref.phraseDispWords.length > 0" class="text"
              [phraseWords]="ref.phraseDispWords"></formatted-phrase>
            </div>
          </ng-container>
      </ng-container>
    </div>
    </p-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="isPhrase && rule.showTablesSection">
    <div style="margin-left: 20px !important">
      <p-panel  [header]="('translate.general.tables' | translate) + ' (' + rule.numberOfTables + ')'"
          [toggleable]="true"
          [collapsed]="true"
          [style]="{ position: 'relative', top: '-1.5em' }"
          >
      <div  *ngIf="rule.showAssociatedTablesSection" class="associatedImages">
      <ng-container *ngFor="let img of rule.associatedImages">
        <ng-container *ngIf="img.showInTile && img.type == 'TABLE'">
          <div style="margin-bottom: 0.5em;">
            <p class="t-footnote figure-type">
              ID: {{ img.assocImageId }}
            </p>
            <async-img [className]="'ind-img'" [url]="img.imgUrl"></async-img>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <ng-container
      *ngTemplateOutlet="tablesTemplate"></ng-container>
    </p-panel>
  </div>
  </ng-container>
  <ng-container *ngIf="isPhrase && rule.showImages">
    <div style="margin-left: 20px !important">
      <p-panel  [header]="('translate.general.associatedImages' | translate) + ' (' + rule.numberOfImages + ')'"
          [toggleable]="true"
          [collapsed]="true"
          [style]="{ position: 'relative', top: '-1.5em' }"
          >
      <div *ngIf="rule.showAssociatedImagesSection" class="associatedImages">
      <ng-container *ngFor="let img of rule.associatedImages">
        <ng-container *ngIf="img.showInTile && img.type != 'TABLE'">
          <div style="margin-bottom: 0.5em;">
            <p class="t-footnote figure-type">
              ID: {{ img.assocImageId }}
            </p>
            <async-img [className]="'ind-img'" [url]="img.imgUrl"></async-img>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <ng-container
      *ngTemplateOutlet="imageTemplate"></ng-container>
    </p-panel>
  </div>
  </ng-container>
  
<div style="margin-left: 20px; margin-top: 0px;">
  <ng-container *ngTemplateOutlet="childTemplate"></ng-container>
</div>

<modal-popup
  *ngIf="selectedRefDoc != null"
  [flexible]="false"
  [hideHeader]="false"
  [title]="selectedRefDoc.docName"
  [isOpen]="selectedRefDoc != null"
  (onClose)="selectedRefDoc = null"
>
  <div class="pdf-container">
    <pdf-viewer
      #docViewer
      [doc]="selectedRefDoc"
      [initialPage]="1"
      [displayDrawMode]="false"
      [displayToggleBoundingBoxes]="false"
      [singlePage]="false"
    ></pdf-viewer>
  </div>
</modal-popup>